import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'df-validator-editor-template',
  templateUrl: './validator-editor-template.component.html',
  styleUrls: ['./validator-editor-template.component.css']
})
export class ValidatorEditorTemplateComponent implements OnInit {
  @Input() caption: string;

  @Input()
  get required(): boolean {
    return this._required;
  }
  set required(value: boolean) {
    this._required = value;
    this.requiredChange.emit(this._required);
  }

  @Output() requiredChange: EventEmitter<boolean>;

  private _required: boolean;

  constructor() {
    this.requiredChange = new EventEmitter<any>();
  }

  ngOnInit() {}
}
